export const UI_CONSTANTS = {
  APP_BAR_HEIGHT: 60, // px
  SIDE_BAR_WIDTH_EXTENDED: 100, // px
  SIDE_BAR_WIDTH_COLLAPSED: 60, // px
};
